import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAdminSupplierUserList = createApi(`GetAdminSupplierUserListSlice`,"GET");

const GetAdminSupplierUserListSlice = createSlice({
  name: 'GetAdminSupplierUserListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminSupplierUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminSupplierUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAdminSupplierUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAdminSupplierUserListSlice.reducer;